/***************************************************************************************************
 * Load `$localize` onto the global scope - used for Angular i18n (if you're using it).
 */
import '@angular/localize/init';

/***************************************************************************************************
 * Zone JS is required by Angular itself. Included with Angular CLI.
 */
import 'zone.js';

/***************************************************************************************************
 * Add global variables if needed (like Node polyfills).
 */
(window as any).global = window;
